import { call, put, takeEvery } from "redux-saga/effects";
import { airAwardAirportRequest, airAwardAirportSuccess, airAwardAirportFailure } from "../slice/airAwardAirportSlice";
import api from "../../../config/api";
import { config } from "../../../config/global";
import i18n from "../../../i18n";

// const API_URL = config?.AIR_AWARD_AIRPORT_API;
const API_URL = config?.AIRPORT_MAIN_URL;
const fetchAirAwardAirportDetail = async payload => {
  const lang = i18n?.language?.split("-")?.[0];
  const headerData = {
    headers: {
      "content-type": "application/json",
      "Access-Control-Expose-Headers": "accessToken",
      "Accept-Language": lang
    },
    loader: true,
    isGenericErr: true
  };
  const response = await api.get(`${API_URL}?lang=${lang}&filter_by=active,TG_REDEMPTION`, headerData);
  return response;
};
function* fetchAirAwardAirport(action) {
  const {
    payload
  } = action;
  try {
    const response = yield call(fetchAirAwardAirportDetail, payload);
    yield put(airAwardAirportSuccess(response.data));
  } catch (error) {
    yield put(airAwardAirportFailure(error?.response));
  }
}
export function* watchAirAwardAirport() {
  yield takeEvery(airAwardAirportRequest.type, fetchAirAwardAirport);
}